import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LanguageService } from '../../core/language/language.service';
import { EServicesService } from '../e-services/e-services.service';
import { AdministrativeProcedureDetailsViewModel } from '../../core/models/administrativeProcedureDetailsViewModel';
import { DatePipe } from '@angular/common';
import { SharedService } from '../../shared/shared.service';

@Component({
  selector: 'app-administrative-procedure-details',
  templateUrl: './administrative-procedure-details.component.html' 
})
export class AdministrativeProcedureDetailsComponent implements OnInit {
  public languageID: number;
  public pathname: string;
  public administrativeProcedureDetails: AdministrativeProcedureDetailsViewModel;
  public eServiceCategoryID: number;

  public StepByStepInstructions: string = "";
  public UsefulLinks: string = "";
  public AvailableInElectronicForm: string = "Ne";
  public loadedBraeadcrumb: boolean = false;

  constructor(private datePipe: DatePipe,
    private _route: ActivatedRoute,
    private _languageService: LanguageService,
    private _eServicesService: EServicesService,
    private _sharedService: SharedService) {
      this.administrativeProcedureDetails = new AdministrativeProcedureDetailsViewModel();      
      this.languageID = this._languageService.selectedLanguageId;      
    }

  ngOnInit() {
    this.pathname = location.pathname;
    this._route.params.subscribe(params => {
      let parentId = + params['Id'];
      this.eServiceCategoryID = params['parentId'];
      if (!isNaN(parentId) && parentId > 0) {
        this.getAdministrativeProcedureDetailsByID(this.languageID, parentId);
      } else {
          console.log('Nedostaje id administrativne procedure')
      }
    });
  }

  getAdministrativeProcedureDetailsByID(languageId: number, administrativeProcedureId : number)
  {    
    this._eServicesService.getAdministrativeProcedureDetailsByID(languageId, administrativeProcedureId).subscribe(result => {
      if(result != null){
        this.administrativeProcedureDetails = result;

        if(this.administrativeProcedureDetails != null)
        {
          let arrayPath = location.pathname.split('/');
          arrayPath[2] = arrayPath[2] + '|' + this.administrativeProcedureDetails.administrativeProcedureCategory.parentCategoryName;
          this.pathname = arrayPath.join('/');        
        }
        this.loadedBraeadcrumb = true;

        this.AvailableInElectronicForm = result.availableInElectronicForm ? "Da" : "Ne";

        this.administrativeProcedureDetails.dateCreated = this.datePipe.transform(this.administrativeProcedureDetails.dateCreated, 'dd.MM.yyyy')

        this.administrativeProcedureDetails.stepByStepInstructions.forEach(step => {
          this.StepByStepInstructions += step.ordinalNumber + ". " + step.text + "\n";
        });
        
        this.administrativeProcedureDetails.usefulLinks.forEach(link => {
          this.UsefulLinks += link.url + "-" + link.description + "\n";
        });
      }
    });
    
  }

  downloadDocument(documentId: number) { 
    let success = false;
    let tempDocument = this.administrativeProcedureDetails.administrativeProcedureDocuments.find(element => element.id === documentId); 

    return  this._eServicesService.downloadAdmProcedureDocument(documentId, this.languageID).subscribe(result => {
        try {
            var blob = new Blob([result], { type: this._sharedService.getContentType('.' + tempDocument.name.split('.')[1]) });
            if (navigator.msSaveBlob)
                navigator.msSaveBlob(blob, tempDocument.name);
            else {
                var saveBlob = navigator.msSaveBlob;
                if (saveBlob === undefined) throw "Not supported";
                saveBlob(blob, tempDocument.name);
            }
            success = true;
        } catch (ex) { }

        if (!success) {
            var urlCreator = window.URL;
            if (urlCreator) {
                var link = document.createElement('a');
                if ('download' in link) {
                    try {
                        // Prepare a blob URL
                        var blob = new Blob([result], { type: this._sharedService.getContentType(tempDocument.name.split('.')[1]) });
                        var url = urlCreator.createObjectURL(blob);
                        link.setAttribute('href', url);
                        link.setAttribute("download", tempDocument.name);

                        const mouseupEvent = new MouseEvent("click", {bubbles : true, cancelable: true});
                        link.dispatchEvent(mouseupEvent);
                        success = true;
                    } catch (ex) { }
                }
            }

            if (!success) {
                try {
                    var blob = new Blob([result], { type: this._sharedService.getContentType(tempDocument.name.split('.')[1]) });
                    var url = urlCreator.createObjectURL(blob);
                    window.open(url, "_blank");
                    success = true;
                } catch (ex) { }
            }
        }
    });
}

}
